import React from 'react';
import FilterableTable from '../filters/FilterableTable';
import ProductRow from './ProductRow';
import { findAllProductsPageable } from '../../actions/product';

const ProductTable = ({  
  deleteProduct,
  updateProduct,
  updateProductWithLogo,
  findProductByIdWithLogo,
  dispatch,
  clearValidationErrors,
  productReducer,
  productCategoryReducer
}) => {
  const { productList, totalElements } = productReducer;
  const productListRow = productList.map((product, index) => (
    <ProductRow
      key={product.id}
      product={product}
      deleteProduct={deleteProduct}
      updateProduct={updateProduct}
      updateProductWithLogo={updateProductWithLogo}
      findProductByIdWithLogo={findProductByIdWithLogo}
      dispatch={dispatch}
      clearValidationErrors={clearValidationErrors}
      productReducer={productReducer}
      productCategoryReducer={productCategoryReducer}
    />
  ));

  const columns = [
    {
      id: 'Naziv',
      name: 'Naziv',
      filter: {
        field: 'productName',
        value: '',
        type: 'LIKE',
      },
    },
    {
      id: 'Cena',
      name: 'Cena',
      filter: {
        field: 'price',
        value: '',
        type: 'DOUBLE',
        clause: 'like'
      },
    },
    {
      id: 'Opis',
      name: 'Opis',
      filter: {
        field: 'description',
        value: '',
        type: 'LIKE',
      },
    },
   
    {
      id: "Kategorija Proizvoda",
      name: "Kategorija Proizvoda",
      filter: {
        field: "productCategory.productCategoryName",
        value: "",
        type: "CHILD_LIKE",
      },
    },
    { id: 'Измена', name: 'Измена' },
    { id: 'Брисање', name: 'Брисање' }
  ];

  return (
    <>
      <FilterableTable
        tableStyle="table-container-with-row-below"
        columns={columns}
        action={findAllProductsPageable}
        rows={productListRow}
        totalElements={totalElements}
        filterPosition
      ></FilterableTable>
    </>
  );
};

export default ProductTable;
